
import { update_assessments_scores } from "@/utils/global";
import Vue from "vue";
export default Vue.extend({
  name: "AnnotationAssessmentScoreCard",
  props: {
    title: {
      type: String,
      required: true
    },
    color_hex: {
      type: String,
      required: true
    },
    color_name: {
      type: String,
      required: true
    },
    value: {
      type: Number,
      required: true
    },
    total: {
      type: Number,
      required: true
    }
  },
  methods: {
    update_assessments_scores
  }
});
